import { render, staticRenderFns } from "./aut.vue?vue&type=template&id=30fbc524"
import script from "./aut.vue?vue&type=script&lang=js"
export * from "./aut.vue?vue&type=script&lang=js"
import style0 from "./aut.vue?vue&type=style&index=0&id=30fbc524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports